import { addHours as addHoursFns } from 'date-fns';

export default function addHours(date: Date, hours: number): Date {
  return addHoursFns(date, hours);
}
